import styled from 'styled-components';

export const RecommendContainer = styled.div`
  color: #fff;
  background: '#ed9d7e';
  display: flex;
`;

export const RecommendWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: 100vh;
  width: 100%;
  padding: 3%;
  background-color: #f2f2f2;
`;

export const RecommendHeading = styled.h1`
  max-width: 24px;
  margin-bottom: 48px;
  line-height: 1.1;
  font-weight: 600;
  color: #012169;
  font-family: 'Gothic821';
`;

export const RecommendPara1 = styled.p`
  margin-bottom: 35px;
  margin-top: 100px;
  font-size: 500;
  line-height: 22px;
  font-weight: bold;
  color: #3f4041;
`;
